import clsx from "clsx"
import { FC, PropsWithChildren } from "react"
import { HomeBgImg } from "@/assets"
import { useAppSelector } from "@/store"
import { AppSelectors } from "@/store/slices/app"
import styles from "./ContentContainer.module.scss"

export const ContentContainer: FC<PropsWithChildren> = ({ children }) => {
  const isDesktop = useAppSelector(AppSelectors.selectIsDesktop())

  return (
    <div className={clsx(styles.ContentContainer)}>
      {isDesktop && (
        <div className={clsx(styles.ContentContainer_bg)}>
          <img src={HomeBgImg} alt="content container bg" />
        </div>
      )}
      <div className={clsx(styles.ContentContainer_safeArea)}>{children}</div>
    </div>
  )
}
